var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('el-button',{staticClass:"forget_btn",attrs:{"type":"primary"},on:{"click":function($event){return _vm.finishBtn()}}},[_vm._v("完成")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_c('div',{staticClass:"suclog"}),_c('h2',[_vm._v("恭喜您成功修改了密码")]),_c('h3',[_vm._v("10秒后自动跳转到登录页，或您可以点击下方的完成立即前往登录")])])
}]

export { render, staticRenderFns }